import React, { FC } from 'react'
import * as ModalStyles from '../../../../../../ModalWindow/modal.styles'
import * as LocalStyles from '../../../styles'
import { KnowledgeQuestion } from '../../trained_questions/knowledge-question'
import { QuestionTypeOption } from '../../types'

interface KnowledgeQuestionSectionProps {
  question: string
  answer: string
  dataSources: Record<string, boolean>
  onCreateNewQuestion: (question: string, answer: string) => void
  buttonIsActive: boolean
  setButtonIsActive: (active: boolean) => void
  onTextWasChange?: (active: boolean) => void
}

export const KnowledgeQuestionSectionWithoutRelevantQuestion: FC<KnowledgeQuestionSectionProps> = ({
  question,
  answer,
  dataSources,
  onCreateNewQuestion,
  onTextWasChange,
}) => {
  const isAnyDataPresent = (): boolean => {
    return Object.entries(dataSources).some(([, present]) => present)
  }

  return (
    <>
      <KnowledgeQuestion
        question={question}
        answer={answer}
        questionType={'main'}
        createQuestionCallback={onCreateNewQuestion}
        onQuestionWasChanged={onTextWasChange}
      />
      {isAnyDataPresent() && (
        <ModalStyles.ModalContainerSection style={{ marginTop: '16px' }}>
          <ModalStyles.SubHeader> Data present in : </ModalStyles.SubHeader>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {Object.entries(dataSources)
              .filter(([, present]) => present)
              .map(([sourceName]) => (
                <LocalStyles.Tag key={sourceName}>{sourceName.replace('_', ' ')}</LocalStyles.Tag>
              ))}
          </div>
        </ModalStyles.ModalContainerSection>
      )}
    </>
  )
}
